import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Product from '../components/Product';
import KioskProduct from '../components/KioskProduct';
import UpsellProduct from '../components/UpsellProduct';
import {incrementProduct, decrementProduct, setProduct, setProductConfig} from '../../product-picker/actions/product-picker';
import { isKioskMode } from 'checkout/selectors/ui';
import { getSubState } from '../../../reducers/subReducerHelpers';
import { isMultiEmbed } from '../../../selectors/ui';
import { getMainEvent } from '../../../selectors/event';

class ProductContainer extends Component {
    constructor() {
        super();
        this.state = {index: 0};
    }

    onQuantityInput = (e) => {
        let configId = null;
        if(this.props.product.single_configuration === true) {
            configId = this.props.product.configurations[0].product_configuration_id;
        }
        this.props.setProduct(this.props.productId, +e.target.value, configId, this.props.reducerKey);
    };

    onIncrement = () => {
        this.props.incrementProduct(this.props.productId, this.props.reducerKey);
        if (this.props.product.single_configuration) {
            this.props.setProductConfig({
                index: this.state.index,
                productId: this.props.productId,
                configurationId: this.props.product.configurations[0].product_configuration_id,
            }, this.props.reducerKey);
            this.setState({index: this.state.index + 1});
        }
    };

    onDecrement = () => {
        this.props.decrementProduct(this.props.productId, this.props.reducerKey);
    };

    render() {

        const commonProps = {
            product: this.props.product,
            onProductIncrement: this.onIncrement,
            onProductDecrement: this.onDecrement,
            productQuantity: this.props.quantity,
            productQuantities: this.props.quantities,
            initialQuantities: this.props.initialQuantities,
            onProductsQuantityInput: this.onQuantityInput,
            reducerKey: this.props.reducerKey,
            showPriceInInfo: this.props.isMultiEmbed
        }

        if (this.props.isKioskMode){
            return(
                <KioskProduct {...commonProps} />
            )
        }

        if (this.props.isProductUpsell) {
            return (
                <UpsellProduct
                    {...commonProps}
                    displayTypeList={!!this.props.displayTypeList}
                    countCartedItems={+this.props.countCartedItems}
                    canEdit={!!this.props.canEdit}
                    disabled={!!this.props.disabled}
                />
            )
        }

        return (
            <Product {...commonProps} />
        )
    }
}

const mapStateToProps = (state, props) => {

    const productState = getSubState(state.products, props.reducerKey);
    const productPickerState = getSubState(state.productPicker, props.reducerKey);

    return {
        product: productState.products[props.productId],
        quantity: productPickerState.productsQuantities[props.productId],
        quantities: Object.keys(productPickerState.availableQuantities).length > 0 ? productPickerState.availableQuantities[props.productId] : productPickerState.productsQuantityArrays[props.productId],
        initialQuantities: productPickerState.productsQuantityArrays[props.productId],
        isKioskMode: isKioskMode(state),
        isMultiEmbed: isMultiEmbed(state),
        feeVerbiage: getMainEvent(state)?.event?.fee_verbiage,
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        incrementProduct,
        decrementProduct,
        setProduct,
        setProductConfig
    }, dispatch);
};

ProductContainer.propTypes = {
    productId: PropTypes.any.isRequired,
    quantity: PropTypes.number,
    quantities: PropTypes.array.isRequired,
    isProductUpsell: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductContainer)
